import {
  AppBar,
  Box,
  Button,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";

import useStyles from "./Header.style";
import { TAuthenticatedUser } from "@byte-coach/hutbot-mapp-sdk-js";
import { useState } from "react";
import { AccountCircle, LogoutRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { useUserContext } from "context/data/userContext";

interface IAccountComponentProps {
  user: TAuthenticatedUser;
}

export interface NavLink {
  title: string;
  to: string;
  active?: boolean;
}

interface IHeaderProps {
  user: TAuthenticatedUser;
  navLinks: NavLink[]
}

function AccountComponent({ user }: IAccountComponentProps) {
  const { logout } = useUserContext();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        startIcon={<AccountCircle />}
      >
        <Typography
          variant="body2"
          noWrap
          component="div"
        >
          {`${user.firstName} ${user.lastName}`}
        </Typography>
      </Button>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { handleClose(); logout(); }}>
          <LogoutRounded />
          {intl.formatMessage({ id: 'app.button.logout.title' })}
        </MenuItem>
      </Menu>
    </>
  )
}

const Header = ({ user, navLinks }: IHeaderProps) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Typography
          variant="h6"
          noWrap
          component="div"
          className={classes.title}
        >
          Product Management
        </Typography>

        <Box className={classes.menu}>
          {navLinks.map((link) => (
            <Link to={link.to} key={link.title}>
              <Button
                size="small"
                key={link.title}
                className={[classes.menuItem, link.active ? classes.activeMenuItem : ''].join(' ')}
              >
                {link.title}
              </Button>
            </Link>
          ))}
        </Box>

        <AccountComponent user={user} />
      </Toolbar>
    </AppBar>
  );
}

export default Header;
